import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

BStar.propTypes = {
  className: PropTypes.string,  // necessaire pour styled
};

function BStar({className}){
  return <i className={className + ' star'}></i>;
}

const Star = styled(BStar)`
  position: relative;
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: .9em;
  margin-right: .9em;
  margin-bottom: 1.2em;
  border-right:  .3em solid transparent;
  border-bottom: .7em solid ${props => {
    if (props.selected !== undefined) {
      return props.selected ? props.theme.starColor : 'lightgrey';
    }
    return props.theme.starColor;
  }};
  border-left:   .3em solid transparent;
  font-size: 12px;
  &:before,
  &:after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: .6em;
    left: -1em;
    border-right:  1em solid transparent;
    border-bottom: .7em solid ${props => {
      if (props.selected !== undefined) {
        return props.selected ? props.theme.starColor : 'lightgrey';
      }
      return props.theme.starColor;
    }};
    border-left:   1em solid transparent;
    transform: rotate(-35deg);
  }
  &:after {
    transform: rotate(35deg);
  }
`;

export default Star;